import React from "react";
import AppList from "../components/AppList";
const Routes = () => {
  return [
    {
      path: "/apps",
      element: <AppList />,
    },
  ];
};

export default Routes;
